import type { RouteRecordRaw } from 'vue-router'

export const startTaskRoutes: RouteRecordRaw[] = [
  {
    path: '/tasks',
    name: 'TaskList',
    component: () => import('./views/TaskListPage.vue'),
    meta: {
      title: 'startTask.Task List',
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/tasks/new',
    name: 'NewTask',
    component: () => import('./views/NewTaskPage.vue'),
    meta: {
      title: 'startTask.Create New Task',
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/tasks/preset-detail',
    name: 'PreSetTaskDetail',
    component: () => import('./preset_task/shared/preset/views/PreSetTaskDetailPage.vue'),
    meta: {
      title: 'startTask.PreSet Task Detail',
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/tasks/document-editor',
    name: 'DocumentEditor',
    component: () => import('./views/DocumentEditorPage.vue'),
    meta: {
      title: 'startTask.Document Editor',
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/tasks/tsign',
    name: 'TSign',
    component: () => import('./views/TSignPage.vue'),
    meta: {
      title: 'startTask.T-Sign',
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/tasks/efiling',
    name: 'EFiling',
    component: () => import('./views/EFilingPage.vue'),
    meta: {
      title: 'startTask.E-Filing',
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/tasks/dev-preview',
    name: 'DevFormPreview',
    component: () => import('./views/DevFormPreview.vue'),
    meta: {
      title: 'DEV - Form Preview',
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/tsign/signing',
    name: 'TSignSigning',
    component: () => import('./views/TSignSigningPage.vue'),
    meta: {
      title: 'startTask.Review and Sign document via T-Sign',
      requiresAuth: false,
      layout: 'blank'
    }
  },
  {
    path: '/tsign/completed',
    name: 'TSignCompleted',
    component: () => import('./views/TSignCompletedPage.vue'),
    meta: {
      title: 'startTask.Signed Document',
      requiresAuth: false,
      layout: 'blank'
    }
  }
]

export default startTaskRoutes
